import { ApplyCouponClickedPayload, BannerClickedPayload, BlogsReadMoreClickedPayload, CartViewedPayload, ContactUsFormSubmitPayload } from "../types";

const isEventTrackingEnabled = process.env.REACT_APP_EVENT_TRACKING === "enabled";

export const selsmartLogoClickedEvent = () => {
  if (!isEventTrackingEnabled) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "selsmart_logo_clicked",
    page_url: window.location.href
  });
};


export const sellNowClickedEvent = (
  cta_text: string,
  location: string
) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "sell_now_clicked",
    cta_text,
    location,
    page_url: window.location.href
  });
};


export const faqClickedEvent = (
  section: string,
  location: string
) => {
  if (!isEventTrackingEnabled) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "faq_clicked",
    section,
    location,
    page_url: window.location.href
  });
};


export const aboutUsClickedEvent = (
  location: string
) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "about_us_clicked",
    location,
    page_url: window.location.href
  });
};

export const blogsClickedEvent = (
  category: string,
  location: string
) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "blogs_clicked",
    category,
    location,
    page_url: window.location.href,
  });
};



export const homeButtonClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "home_button_clicked",
    location, 
    page_url: window.location.href, 
  });
};

export const profileClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "profile_clicked",
    location, 
    page_url: window.location.href, 
  });
};

export const pickupsViewDetailsClickedEvent = (
  prid: number,
  product_name: string,
  status: string
) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pickups_view_details_clicked",
    prid,
    product_name,
    status,
    page_url: window.location.href,
  });
};

export const profilePickupSearchClickedEvent = (
  results_count: number,
  filters: string[],
) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "profile_pickup_search_clicked",
    results_count,
    filters,
    page_url: window.location.href,
  });
};


export const referralTabClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "referral_tab_clicked",
    location, 
    page_url: window.location.href,
  });
};



export const referralCodeCopiedEvent = (referral_code_hash: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "referral_code_copied",
    referral_code_hash,
    page_url: window.location.href,
  });
};

export const referralLinkCopiedEvent = (referral_link_id: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "referral_link_copied",
    referral_link_id,
    page_url: window.location.href,
  });
};

export const contactUsClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "contact_us_clicked",
    location,
    page_url: window.location.href,
  });
};

export const contactUsFormSubmitEvent = ({
  form_id,
  success,
  failure_reason,
}: ContactUsFormSubmitPayload) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "contact_us_form_submit",
    form_id,
    success,
    failure_reason: success ? "" : failure_reason || "",
    page_url: window.location.href,
  });
};


export const facebookClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "facebook_clicked",
    location,
    page_url: window.location.href,
  });
};

export const instagramClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "instagram_clicked",
    location,
    page_url: window.location.href,
  });
};

export const linkedinClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "linkedin_clicked",
    location,
    page_url: window.location.href,
  });
};

export const youtubeClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "youtube_clicked",
    location,
    page_url: window.location.href,
  });
};


export const bulkPickupRequestClickedEvent = (location: string) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "bulk_pickup_request_clicked",
    location,              
    page_url: window.location.href,
  });
};

export const bannerClickedEvent = ({
  banner_id,
  banner_position,
  campaign,
}: BannerClickedPayload) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "banner_clicked",
    banner_id,
    banner_position,
    campaign,
    page_url: window.location.href,
  });
};

export const blogsReadMoreClickedEvent = ({
  blog_id,
  blog_title,
  category,
  destination_url,
}: BlogsReadMoreClickedPayload) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "blogs_read_more_clicked",
    blog_id,
    blog_title,
    category,
    destination_url,
    page_url: window.location.href,
  });
};


export const resendOtpClickedEvent = (mobile_no: string) => {
  if (!isEventTrackingEnabled) return; 

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "resend_otp_clicked",
    mobile_no,
    page_url: window.location.href,
  });
};


export const applyCouponClickedEvent = ({
  items,
}: ApplyCouponClickedPayload) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "apply_coupon_clicked",
    items,
    page_url: window.location.href,
  });
};




export const cartViewedEvent = ({ items }: CartViewedPayload) => {
  if (!isEventTrackingEnabled) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cart_viewed",
    items,
    page_url: window.location.href, 
  });
};
